// 결제 관련
import {Steps} from "@app/pages/auth/Signup/type"
import {Path} from "@app/route_path"
import {Button, useModal, LoadingButton} from "@shortsworks/ui"
import { useVerifyCard } from "@shortsworks/user-api";
import { useLocation, useNavigate } from "react-router-dom";
import { useFormWithSchema } from "@app/components/forms/hooks/useFormWithSchema";
import { useEffect } from "react";
import uuid from "react-uuid";
import { CommonErrorModal } from "@app/components/modals/CommonErrorModal";
import FormContainer from "@app/components/forms/container/FormContainer";
import { PaymentMethodSchema } from "@app/pages/auth/Signup/paymentMethodSchema";

export const PaymentMethodForm = () => {
  const { showModal } = useModal();
  const {mutateAsync: mutateAsyncVerifyCard, isPending: isPendingVerfyCard} = useVerifyCard();

  const location = useLocation();
  const navigate = useNavigate();

  const { form, schemas, parseForm, setFormValues } = useFormWithSchema({
    formSchemas: PaymentMethodSchema,
    mode: "onChange",
  });

  // radioGroup에서 defaultValue 없는 현상 확인 필요
  useEffect(() => {
    setFormValues({
      cardType: "personal",
    });
  }, []);

  const goPrevious = () => {
    return navigate(Path.SIGNUP + Steps.STEP5);
  };

  const goNext = async () => {
    const parsedPorm = parseForm();
    if (!parsedPorm.success) {
      return;
    }

    const { cardNumber, cardExpiration, cardPassword, customerBirthday } =
      parsedPorm.data;
    const [cardExpirationMonth, cardExpirationYear] =
      cardExpiration.match(/.{2}/g);

    // 이전 스텝에서 넘어오지 않는 경우 체크 필요
    const { platformName, email } = location.state;

    try {
      const result = await mutateAsyncVerifyCard({
        data: {
          customerKey: uuid(),
          cardNumber,
          cardExpirationMonth,
          cardExpirationYear,
          cardPassword,
          customerBirthday,
          customerName: platformName,
          customerEmail: email,
        },
      });

      if (!result.data.success) {
        return showModal(CommonErrorModal, {
          title: "카드 등록에 실패했습니다.",
        });
      }

      return navigate(Path.SIGNUP + Steps.STEP5, {
        state: {
          ...location.state,
          cardNumber,
          cardExpirationMonth,
          cardExpirationYear,
          cardPassword,
          customerBirthday,
          customerName: platformName,
          customerEmail: email,
        },
      });
    } catch (error) {
      return showModal(CommonErrorModal, {
        title: "카드 등록에 실패했습니다.",
      });
    }
  };

  const skip = () => {
    return navigate("/signup/step5", {
      state: {
        ...location.state,
      },
    });
  };

  return (
    <div>
      <h1 className="font-bold text-xl mb-4">카드정보(선택)</h1>
      <FormContainer schemas={schemas} form={form} />

      <div className="mt-6">
        <div className="flex flex-row w-full">
          <Button
            className="w-full mr-4"
            variant="secondary"
            onClick={goPrevious}
          >
            이전
          </Button>
          <LoadingButton loading={isPendingVerfyCard} className="w-full" onClick={goNext}>
            다음
          </LoadingButton>
        </div>
        <Button className="mt-6 w-full" variant="outline" onClick={skip}>
          건너뛰기
        </Button>
      </div>
    </div>
  );
};
